var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.isVisible,"color":_vm.color,"timeout":_vm.timeout,"bottom":_vm.y,"right":_vm.x},on:{"change":_vm.closeSnackbar}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"white"},on:{"click":_vm.closeSnackbar}},[_vm._v("Close")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eba46fea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/Snackbar.vue
// module id = 69
// module chunks = 0